"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertState = void 0;
var AlertState;
exports.AlertState = AlertState;

(function (AlertState) {
  AlertState["SUCCESS"] = "success";
  AlertState["FAILURE"] = "failure";
})(AlertState || (exports.AlertState = AlertState = {}));